<div class="table-outer-wrapper" [ngClass]="'table-' + uniqueId">
  <!-- Header: Scrolls horizontally with body, but stays fixed vertically -->
  <div class="header-container" #headerContainer
       [tableColumnManager]="uniqueId"
       [defaultWidths]="defaultWidths"
       [columnGroups]="jobsGroupByType ? groupedColumnGroups : columnGroups"
       [settings]="settings"
       (settingsChange)="onSettingsChange.emit($event)">
    <div class="table-inner-wrapper">
      <div class="jobs-table-list-container">
        <div class="tr sticky-header">
          <!-- Merged header for drag, checkbox, and ID -->
          <div class="th col-id sticky-col">
            {{ settings?.columns?.id ? ('ID' | translate) : '' }}
            <app-table-column-insert-button></app-table-column-insert-button>
          </div>

          <ng-container *ngIf="!jobsGroupByType">
            <ng-container *ngIf="settings?.columns?.address">
              <div class="th col-address col-pickup-address" translate>
                Pickup Address
                <app-table-column-insert-button column="address"></app-table-column-insert-button>
              </div>
              <div class="th col-address col-dropoff-address" translate>
                Dropoff Address
                <app-table-column-insert-button column="address"></app-table-column-insert-button>
              </div>
            </ng-container>

            @if (settings?.columns?.timeWindow) {
              <div class="th col-time-window" translate>
                Time Window
                <app-table-column-insert-button column="timeWindow"></app-table-column-insert-button>
              </div>
            }
            @if (settings?.columns?.contacts) {
              <div class="th col-contact" translate>
                Contacts
                <app-table-column-insert-button column="contacts"></app-table-column-insert-button>
              </div>
            }
            @if (settings?.columns?.serviceTime) {
              <div class="th col-service-time" translate>
                Service Time
                <app-table-column-insert-button column="serviceTime"></app-table-column-insert-button>
              </div>
            }
            @if (settings?.columns?.sla) {
              <div class="th col-sla" translate>
                SLA
                <app-table-column-insert-button column="sla"></app-table-column-insert-button>
              </div>
            }
          </ng-container>

          @if (settings?.columns?.account) {
            <div class="th col-account" translate>
              Account
              <app-table-column-insert-button column="account"></app-table-column-insert-button>
            </div>
          }

          <ng-container *ngIf="!jobsGroupByType">
            @if (settings?.columns?.vehicles) {
              <div class="th col-vehicles" translate>
                Vehicles
                <app-table-column-insert-button column="vehicles"></app-table-column-insert-button>
              </div>
            }
            @if (settings?.columns?.accountExternalId) {
              <div class="th col-account-ext-id" translate>
                Account External ID
                <app-table-column-insert-button column="accountExternalId"></app-table-column-insert-button>
              </div>
            }
            @if (settings?.columns?.labels) {
              <div class="th col-labels" translate>
                Labels
                <app-table-column-insert-button column="labels"></app-table-column-insert-button>
              </div>
            }
            @if (settings?.columns?.tags) {
              <div class="th col-tags" translate>
                Tags
                <app-table-column-insert-button column="tags"></app-table-column-insert-button>
              </div>
            }
          </ng-container>

          @if (settings?.columns?.skills) {
            <div class="th col-skills" translate>
              Skills
              <app-table-column-insert-button column="skills"></app-table-column-insert-button>
            </div>
          }

          <ng-container *ngIf="!jobsGroupByType">
            @if (settings?.columns?.packages) {
              <div class="th col-packages" translate>
                Packages
                <app-table-column-insert-button column="packages"></app-table-column-insert-button>
              </div>
            }
            @if (settings?.columns?.leftoverReason) {
              <div class="th col-leftover-reason" translate>
                Leftover Reason
                <app-table-column-insert-button column="leftoverReason"></app-table-column-insert-button>
              </div>
            }
            @if (settings?.columns?.recurringServiceTemplateId) {
              <div class="th col-recurring" translate>
                Recurring
                <app-table-column-insert-button column="recurringServiceTemplateId"></app-table-column-insert-button>
              </div>
            }
            <!-- Load Columns -->
            @if (settings?.load?.weight) {
              <div class="th col-load col-load-weight" translate>
                Weight
                <app-table-column-insert-button column="weight" group="load"></app-table-column-insert-button>
              </div>
            }
            @if (settings?.load?.volume) {
              <div class="th col-load col-load-volume" translate>
                Volume
                <app-table-column-insert-button column="volume" group="load"></app-table-column-insert-button>
              </div>
            }
            @if (settings?.load?.packages) {
              <div class="th col-load col-load-packages" translate>
                Packages
                <app-table-column-insert-button column="packages" group="load"></app-table-column-insert-button>
              </div>
            }
            @if (settings?.load?.value) {
              <div class="th col-load col-load-value" translate>
                Value
                <app-table-column-insert-button column="value" group="load"></app-table-column-insert-button>
              </div>
            }
            @if (settings?.load?.pallets) {
              <div class="th col-load col-load-pallets" translate>
                Pallets
                <app-table-column-insert-button column="pallets" group="load"></app-table-column-insert-button>
              </div>
            }
            @if (settings?.load?.spots) {
              <div class="th col-load col-load-spots" translate>
                Spots
                <app-table-column-insert-button column="spots" group="load"></app-table-column-insert-button>
              </div>
            }
          </ng-container>

        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!jobs" class="flex layout-row layout-align-center-center padding-20">
    <div class="spinner-border" role="status"></div>
  </div>

  <div *ngIf="!!jobs"
       class="body-drop-list-wrapper"
       cdkDropList
       id="{{panel.id}}"
       [cdkDropListData]="jobs"
       [cdkDropListConnectedTo]="connectedPanelIds"
       [cdkDropListSortingDisabled]="true"
       (cdkDropListDropped)="drop($event)">

    <div *ngIf="!jobs?.length" class="flex layout-row layout-align-center-center padding-20">
      <app-empty-state src="assets/images/empty_state/empty_state_dispatching.png" text="No Services Found"></app-empty-state>
    </div>

    <!-- Body: Handles vertical scrolling (starting under header) and horizontal scrolling -->
    <cdk-virtual-scroll-viewport *ngIf="jobs?.length"
                                 class="body-container"
                                 autosize
                                 [minBufferPx]="1000"
                                 [maxBufferPx]="2000"
                                 #bodyContainer
                                 (scroll)="onBodyScroll($event)">

    <div class="table-inner-wrapper">

      <div class="jobs-table-list-container">

        <ng-container>
          <app-planning-draft-jobs-table-list-row
               *cdkVirtualFor="let job of jobs; trackBy: trackById"
               [job]="job"
               [draft]="draft"
               [jobsGroupByType]="jobsGroupByType"
               [settings]="settings"
               [isSelected]="selectedKeys[job.id]"
               [isLocked]="routesByJobMap[job.id]?.locked"
               [routeIndexes]="getRouteIndexes(job)"
               [routeColor]="getRouteColor(job)"
               [isObligatedTimeWindow]="getIsObligatedTimeWindow(job)"
               [query]="query"
               [type]="type"
               [isGroupExpanded]="expandedGroupedJobs[job.id]"
               (dblclick)="onRowDoubleClick($event, job)"
               cdkDrag
               [cdkDragData]="job"
               [cdkDragDisabled]="routesByJobMap[job.id]?.locked"
               (contextmenu)="$event.preventDefault(); onContextMenu.emit({event: $event, job: job})"
               (onToggleSelectedJob)="onToggleSelectedJob($event.jobIds, $event.isSelected)"
               (onViewJob)="onViewJob.emit($event)"
               (onToggleObligateTimeWindow)="onToggleObligateTimeWindow.emit($event)"
               (onGroupExpanded)="onGroupExpanded.emit($event)"
               (onReverseJobSplit)="onReverseJobSplit.emit($event)">

            <!-- Drag Preview -->
            <div *ngIf="selectedIds.length > 1 && selectedKeys[job.id]; else normalPreview">
              <div *cdkDragPreview
                   id="app-planning-draft-jobs-panel-editable-list-preview-drag-multiple-jobs-container">
                {{ 'DRAGGING_X_ITEMS.JOBS' | translate:{X: selectedIds.length} }}
              </div>
            </div>

            <ng-template #normalPreview>
              <div *cdkDragPreview class="tr drag-preview jobs-table-drag-preview" [ngClass]="{'group-row': !!job.groupedByType}">
                <div class="td col-id">
                  {{ job.groupedByType ? (job.jobIds.length + ' services') : (job.externalId || job.id) }}
               </div>
               <div class="td col-address">
                  {{ job.groupedByType ? job.address?.city : (job.stops[0]?.address | bringozAddress) }}
                </div>
              </div>
            </ng-template>

            <!-- Placeholder -->
            <div *cdkDragPlaceholder class="tr drag-placeholder"></div>

            <!-- Drag Handle -->
            <div drag-handle cdkDragHandle style="display: flex; align-items: center; flex-shrink: 0;">
              <bringoz-icon iconName="drag" class="secondary-100 pointer"></bringoz-icon>
            </div>

          </app-planning-draft-jobs-table-list-row>
        </ng-container>

      </div>

    </div>
  </cdk-virtual-scroll-viewport>
  </div>
</div>
